export { default as skyminer1 } from './skyminer_1.png';
export { default as skyminer2 } from './skyminer_2.png';
export { default as skyminer3 } from './skyminer_3.png';
export { default as skyminer4 } from './skyminer_4.png';
export { default as skyminer5 } from './skyminer_5.png';
export { default as skyminer6 } from './skyminer_6.png';
export { default as skyminer7 } from './skyminer_7.png';
export { default as skyminer8 } from './skyminer_8.png';



// WEBPACK FOOTER //
// ./src/components/Skyminer/components/GalleryHDK/images/index.js